import PastBookingTable from 'src/modules/Report/components/PastBookingTable';
import { FC } from 'react';
import { Booking } from 'src/modules/BookingManagement/models';
import { I18N, } from 'src/shared/constants/constants';
import { useTranslation } from 'react-i18next';

interface PastBookingProps {
  pastBookingData: Booking[];
}
export const PastBooking: FC<PastBookingProps> = ({
  pastBookingData: pastBookingData,
}) => {
  const { t } = useTranslation(I18N.BOOKING_MANAGEMENT);
  return (
    <>
      <PastBookingTable
        pastBookingData={pastBookingData}
      />
    </>
  );
};
